
import http from '../../api/http';

const Records = ( Model ) => ({

  slug: Model.slug,

  Meta: {

    slug: Model.slug,

    getRecords: async (params = {}) => {
      const response = await http.get(`/${Model.slug}`, { params });
      return response.data;
    },
    createRecord: async (payload) => {
      const response = await http.post(`/${Model.slug}`, payload);
      return response.data;
    },

    getRecord: async (slug) => {
      const response = await http.get(`/${Model.slug}/${slug}`);
      return response.data;
    },
    updateRecord: async (slug, payload) => {
      const response = await http.patch(`/${Model.slug}/${slug}`, payload);
      return response.data;
    },
    deleteRecord: async (slug) => {
      await http.delete(`/${Model.slug}/${slug}`);
    },

  },

  Data: {

    slug: Model.slug,

    getRecords: async (params = {}) => {
      const response = await http.get(`/${Model.slug}`, { params });
      return response.data;
    },
    createRecord: async (payload) => {
      const response = await http.post(`/${Model.slug}`, payload);
      return response.data;
    },

    getRecord: async (id) => {
      const response = await http.get(`/${Model.slug}/${id}`);
      return response.data;
    },
    updateRecord: async (id, payload) => {
      const response = await http.patch(`/${Model.slug}/${id}`, payload);
      return response.data;
    },
    deleteRecord: async (id) => {
      await http.delete(`/${Model.slug}/${id}`);
    },

  }

});

export default Records;